import { fetchApi } from "./fetchApi";

export default {
  config() {
    return fetchApi({
      method: "get",
      url: "/config",
    });
  },
  getSession() {
    return fetchApi({
      method: "get",
      url: "/api/session",
    });
  },
  login({ password, username }) {
    return fetchApi({
      data: {
        password,
        username,
      },
      method: "post",
      url: "/api/login",
    });
  },
  refresh() {
    return fetchApi({
      method: "get",
      url: "/api/session/refresh",
    });
  },
  updateUserConfiguration(userConfiguration) {
    return fetchApi({
      data: {
        userConfiguration,
      },
      method: "post",
      url: "/api/session",
    });
  },
  updateServiceArea(serviceArea) {
    return fetchApi({
      data: {
        serviceArea,
      },
      method: "put",
      url: "/api/session",
    });
  },
};
